import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledCard = styled.div`
  background-color: #edf8fb;
  border-radius: 12px;
  padding: 1.25rem;
  position: relative;
`;

const CardSubtitle = styled.div`
  margin-bottom: 0.5rem;
  color: #6c757d;
`;

const CardTitle = styled.span`
  font-size: 1rem;
  color: black;
  font-weight: 500;
`;

const CardContent = styled.h1`
  color: #000;
  font-weight: bold;
  text-align: left;
  margin: 0;
`;

const Card = ({ title, content, textLink, href, subtitle }) => (
  <StyledCard>
    <div className="d-flex justify-content-between mb-4 gap-2">
      <CardTitle>{title}</CardTitle>
      {textLink && <Link to={href}>{textLink}</Link>}
    </div>
    {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
    <CardContent>{content}</CardContent>
  </StyledCard>
);

Card.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  textLink: PropTypes.string,
  href: PropTypes.string,
  subtitle: PropTypes.string
};

Card.defaultProps = {
  content: '',
  textLink: null,
  href: null,
  subtitle: null
};

export default Card;
